'use client';

import { ProfileSection, type ProfileSectionType, TradingSection } from '@/components';
import type { User } from '@/types';

interface ProfileContentProps {
  activeSection: ProfileSectionType;
  user: User;
  name: string;
  avatarUrl: string | null;
  isSaving: boolean;
  hasChanges: boolean;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSave: () => void;
  isUploading?: boolean;
  onAvatarUpload?: () => void;
  onFileChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputRef?: React.RefObject<HTMLInputElement>;
}

export function ProfileContent({
  activeSection,
  user,
  name,
  avatarUrl,
  isSaving,
  hasChanges,
  onNameChange,
  onSave,
  isUploading,
  onAvatarUpload,
  onFileChange,
  fileInputRef,
}: ProfileContentProps) {
  switch (activeSection) {
    case 'profile':
      return (
        <ProfileSection
          user={user}
          name={name}
          avatarUrl={avatarUrl}
          isSaving={isSaving}
          hasChanges={hasChanges}
          onNameChange={onNameChange}
          onSave={onSave}
          isUploading={isUploading}
          onAvatarUpload={onAvatarUpload}
          onFileChange={onFileChange}
          fileInputRef={fileInputRef}
        />
      );
    case 'trading':
      return <TradingSection />;

    default:
      return null;
  }
}
